"use client";

import { Tabs } from "@base-ui-components/react/tabs";
import { classed } from "@trydig/ui";

export const TabsRoot = classed(Tabs.Root, "");
export const TabsList = classed(Tabs.List, "");
export const TabsPanel = classed(Tabs.Panel, "");

export const TabsIndicator = classed(Tabs.Indicator, "");

export const TabsTrigger = classed(Tabs.Tab, "");
